var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0866 12.0199C41.0042 13.161 37.0936 14.8455 33.4599 17.0281V17.0204L23.4435 10.895L9.90601 24.8254L16.3088 34.6646C14.2309 38.3596 12.6579 42.3167 11.6319 46.4299L0.220947 49.1806L0.490623 68.6046L11.9786 71.0317C13.1185 75.1157 14.8002 79.0286 16.9791 82.6661L10.8614 92.6824L24.7919 106.22L34.6233 99.8249C38.3196 101.9 42.2763 103.473 46.3887 104.502L49.147 115.913L68.5711 115.635L70.9904 104.155C75.0737 103.009 78.9862 101.325 82.6248 99.1468L92.6412 105.265L106.179 91.3418L99.7836 81.5026C101.858 77.806 103.431 73.8494 104.46 69.7372L115.871 66.9789L115.594 47.5626L104.114 45.1278C102.968 41.0472 101.283 37.1373 99.1056 33.5011L105.223 23.4848L91.3005 9.94726L81.4614 16.35C77.7663 14.2721 73.8092 12.6992 69.696 11.6732L66.9376 0.262207L47.5213 0.531877L45.0866 12.0199ZM58.0077 85.0161C72.9012 85.0161 84.9748 72.9425 84.9748 58.0489C84.9748 43.1554 72.9012 31.0818 58.0077 31.0818C43.1141 31.0818 31.0405 43.1554 31.0405 58.0489C31.0405 72.9425 43.1141 85.0161 58.0077 85.0161Z",
    fill: "#E7B92A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowGear);
export default __webpack_public_path__ + "static/media/yellow-gear.f06f2e7db24589fb4f94994e94946489.svg";
export { ForwardRef as ReactComponent };